import ModalWrapper from '@/components/modal/ModalWrapper'

import { gridStateActions, useGridSnap } from '../../grid/grid.store'
import { useCellState } from '../CellContext'
import { getContentForTextCell } from '../content/content.helpers'

export function EditorConflictDialog({
  onDiscard,
  onOverwrite,
}: {
  onDiscard: () => void
  onOverwrite: () => void
}) {
  const {
    editor: { showConflictDialog },
  } = useGridSnap()

  if (!showConflictDialog) return null

  return (
    <ModalWrapper
      open={showConflictDialog}
      title="Content conflict"
      buttons={[
        {
          text: 'Discard my changes',
          onClick: onDiscard,
          colour: 'main',
        },
        {
          text: 'Save and overwrite',
          onClick: onOverwrite,
          colour: 'red',
        },
      ]}
    >
      <div className="space-y-4 text-sm text-gray-300">
        <p>
          The contents of this cell were modified elsewhere after you started
          editing it.
        </p>

        <p>You have two choices, please choose carefully:</p>

        <ul>
          <li>
            • You can <b>discard</b> your changes and reload the latest cell
            content.
          </li>
          <li>
            • You can <b>save</b> your changes, overwriting the latest cell
            content.
          </li>
        </ul>

        <hr className="my-6 opacity-25" />

        <ContentDiff />
      </div>
    </ModalWrapper>
  )
}

function ContentDiff() {
  const { cell } = useCellState()
  const { getEditorContent } = gridStateActions.editor

  const latestContent = getContentForTextCell(cell?.content)

  const currentEditorContent = getEditorContent()

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="">
        <div className="text-sm font-medium mb-1">Latest content:</div>
        <div className="bg-gray-700/30 border border-gray-800 rounded-md p-3 flex gap-3">
          <p className="text-xs">{latestContent}</p>
        </div>
      </div>
      <div>
        <div className="text-sm font-medium mb-1">Your unsaved content:</div>
        <div className="bg-red-600/10 border border-gray-800 rounded-md p-3 flex gap-3">
          <p className="text-xs">{currentEditorContent}</p>
        </div>
      </div>
    </div>
  )
}
